import { denormalize } from 'normalizr'
import entitySchema from '@redux/entitySchema'

function denormalizeEntity(entityType, entity, entities){
  return denormalize(entity, entitySchema[entityType], entities)
}

export default denormalizeEntity
